import ForgePage from './components/Forge/ForgePage';

const routes = [
     {
          'path': '/',
          'component': ForgePage,
          'exact': true
     },
];

export default routes;

